import { Expose } from "class-transformer"
import { IsDefined, IsNumber } from "class-validator"

export class PreparationChatEntity {
    @Expose()
    @IsDefined()
    @IsNumber()
    id!: number;
}